import { Tag } from "antd";
import type { DeploymentTrack } from "@/core/deployTrackStore";
import { useDeployTrackStore } from "@/core/deployTrackStore";

/**
 * 纯展示部分：只依赖入参，不碰 store。
 * <p>
 * 单独拆出来是为了可测——zustand v4 在 SSR 下把 getServerSnapshot 指向**初始 state**
 * （`api.getServerState || api.getInitialState`），本仓测试用 renderToStaticMarkup，
 * 因此连接了 store 的组件在测试里永远只看得到初始值，无法断言轨道切换后的渲染。
 */
export function DeployTrackBadgeView({ track }: { track: DeploymentTrack }) {
	// 稳定轨道是常态，不显示角标以免打扰
	if (track !== "PRE") {
		return null;
	}

	return (
		<Tag
			color="orange"
			style={{ marginInlineEnd: 8 }}
			title="你的账号在 PRE 名单里，接口走预发布池。移出名单后刷新即回稳定环境。"
		>
			预发布环境
		</Tag>
	);
}

/**
 * 部署轨道角标。单域名按人分轨后，运营从同一个 op.bujuan.me 进来，光看地址栏无从判断自己在哪条轨道，
 * 因此必须有可见提示，否则「我这边是好的 / 我这边不是」会变成排障噪音。
 */
export default function DeployTrackBadge() {
	const track = useDeployTrackStore((state) => state.track);
	return <DeployTrackBadgeView track={track} />;
}
